import BetModel from "../../../../vendor_core/core/src/model/BetModel";
import CurrencyUtils from "../../../../vendor_core/core/src/utils/CurrencyUtils";

/** Formats the amounts and dates of the round being shown, in the currency it was played in. */
export default class BURHistoryFormatter {
    constructor(
        public readonly currency: string,
        public readonly bet: number
    ) {}

    // "-" when the amount is missing
    public money(value: number | undefined): string {
        if (value === undefined || !Number.isFinite(value)) {
            return "-";
        }

        const localization = BetModel.currencyLocalization;
        if (localization && localization.currency.ISO === this.currency) {
            return CurrencyUtils.formatCurrency(value, localization);
        }
        return `${value.toFixed(2)} ${this.currency || ""}`.trim();
    }

    public date(value: string): string {
        const date = new Date(value);
        return isNaN(date.getTime()) ? value || "-" : date.toLocaleString();
    }

    // "Label - €amount", as used by the section titles
    public withAmount(label: string, amount: number | undefined): string {
        return `${label} - ${this.money(amount)}`;
    }
}
